// extracted by mini-css-extract-plugin
export default {"overlay":"DocumentImageOverlay-module__overlay-ilDO","failed":"DocumentImageOverlay-module__failed-fYqP"};